import { CartRepository } from '@lib/api/repository/cart/cart.repository';
import { CartItemInput } from '@lib/types';

export default class CartService {
  constructor(private repository: CartRepository) {}

  listProducts(signal?: AbortSignal) {
    return this.repository.listProducts(signal);
  }

  addProduct(productOfferId: string, quantity: number) {
    return this.repository.addProduct(productOfferId, quantity);
  }

  updateProduct(id: string, quantity: number) {
    return this.repository.updateProduct(id, quantity);
  }

  removeProduct(id: string) {
    return this.repository.removeProduct(id);
  }

  list(signal?: AbortSignal) {
    return this.repository.list(signal);
  }

  add(input: CartItemInput) {
    return this.repository.add(input);
  }

  addBatch(items: CartItemInput[], idempotencyKey: string) {
    return this.repository.addBatch(items, idempotencyKey);
  }

  import(items: CartItemInput[]) {
    return this.repository.import(items);
  }

  update(id: string, quantity: number) {
    return this.repository.update(id, quantity);
  }

  remove(id: string) {
    return this.repository.remove(id);
  }

  clearStore(storeId: string) {
    return this.repository.clearStore(storeId);
  }
}
